var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 13.3333C11.6667 14.8083 11.025 16.1416 9.99999 17.05C9.11666 17.85 7.94999 18.3333 6.66666 18.3333C3.90832 18.3333 1.66666 16.0916 1.66666 13.3333C1.66666 11.0333 3.23332 9.0833 5.34999 8.5083C5.92499 9.9583 7.15832 11.075 8.68332 11.4916C9.09999 11.6083 9.54166 11.6666 9.99999 11.6666C10.4583 11.6666 10.9 11.6083 11.3167 11.4916C11.5417 12.0583 11.6667 12.6833 11.6667 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66663C15 7.31663 14.875 7.94163 14.65 8.50829C14.075 9.95829 12.8417 11.075 11.3167 11.4916C10.9 11.6083 10.4583 11.6666 10 11.6666C9.54167 11.6666 9.1 11.6083 8.68333 11.4916C7.15833 11.075 5.925 9.95829 5.35 8.50829C5.125 7.94163 5 7.31663 5 6.66663C5 3.90829 7.24167 1.66663 10 1.66663C12.7583 1.66663 15 3.90829 15 6.66663Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.3333C18.3333 16.0916 16.0917 18.3333 13.3333 18.3333C12.05 18.3333 10.8833 17.85 10 17.05C11.025 16.1416 11.6667 14.8083 11.6667 13.3333C11.6667 12.6833 11.5417 12.0583 11.3167 11.4916C12.8417 11.075 14.075 9.9583 14.65 8.5083C16.7667 9.0833 18.3333 11.0333 18.3333 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.307fae93b7f0a7c6470f4d8014c415b8.svg";
export { ForwardRef as ReactComponent };